/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.detail.modals.cardholderExpiration.controllers', [
  'ui.bootstrap',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.themesHelper',
  'acme.common.service.userPreferences'
])

.controller('MembershipDetailModalsCardholderExpirationController', [
  '$scope',
  '$filter',
  '$uibModalInstance',
  'HelpersService',
  'CalendarService',
  'ThemesHelperService',
  'UserPreferencesService',
  'membership',
  'membershipDateType',
  'membershipJoinedDate',
  'membershipStartDate',
  'membershipExpirationDate', function($scope,
                                       $filter,
                                       $uibModalInstance,
                                       HelpersService,
                                       CalendarService,
                                       ThemesHelperService,
                                       UserPreferencesService,
                                       membership,
                                       membershipDateType,
                                       membershipJoinedDate,
                                       membershipStartDate,
                                       membershipExpirationDate) {

    $scope.membershipDetailModalsCardholderExpiration = {

      model: membership,
      dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),
      dateFormats: HelpersService.dateFormats,
      targetTz: '',
      membershipDateType: membershipDateType,
      membershipJoinedDate: '',
      membershipStartDate: '',
      membershipExpirationDate: '',
      title: '',
      type: {
        membershipJoinedDate: {
          title: 'Join Date Change',
          contentNoOptions: 'Update the Join Date on this membership to',
          contentOptions: {
            p1: 'With this joined date change, there are membership cards joining after the membership term.',
            p2: 'Update the joined date on the following cards to'
          }
        },
        membershipStartDate: {
          title: 'Start Date Change',
          contentNoOptions: 'With this start date change, the following cards will be updated to start at the same time',
          contentOptions: {
            p1: 'With this start date change, there are membership cards starting after the membership term.',
            p2: 'Update the start date on the following cards to'
          }
        },
        membershipExpirationDate: {
          title: 'Expiration Date Change',
          contentNoOptions: 'With this expiration date change, the following cards will be updated to expire at the same time',
          contentOptions: {
            p1: 'With this expiration date change, there are membership cards expiring before the membership term.',
            p2: 'Update the expiration date on the following cards to'
          }
        },
      },


      init: function() {
        this.setTargetTz();
        this.updateCardholders();
        this.membershipJoinedDate = $filter('date')(CalendarService.parseDate(membershipJoinedDate), this.dateFormat);
        this.membershipStartDate = $filter('date')(CalendarService.parseDate(membershipStartDate), this.dateFormat);
        this.membershipExpirationDate = $filter('date')(CalendarService.parseDate(membershipExpirationDate), this.dateFormat);
      },

      isDateType: function(type) {
        return this.membershipDateType === type;
      },

      updateCardholders: function() {
        var i, ii;

        for (i=0,ii=this.model.cardholders.length;i<ii;i++) {
          this.model.cardholders[i].displayJoinedDate = $filter('date')(CalendarService.parseDate(this.model.membershipJoinedDate), this.dateFormat);
          this.model.cardholders[i].displayStartDate = $filter('date')(CalendarService.parseDate(this.model.membershipStartDate), this.dateFormat);
          this.model.cardholders[i].displayExpirationDate = $filter('date')(CalendarService.parseDate(this.model.cardholders[i].expirationDate), this.dateFormat);
        }
      },

      isBackdating: function() {
        switch(this.membershipDateType) {
          case 'membershipJoinedDate': 
            return true;
          case 'membershipStartDate': 
            return true;
          default: 
            return (membershipExpirationDate.getTime() < CalendarService.parseDate(this.model.membershipExpirationDate).getTime());
        }
      },

      setTargetTz: function() {
        var d = null;
        
        switch(this.membershipDateType) {
          case 'membershipJoinedDate': d = membershipJoinedDate; break;
          case 'membershipStartDate': d = membershipStartDate; break;
          default: d = membershipExpirationDate; break;
        }

        this.targetTz = moment.tz([d.getFullYear(), d.getMonth(), d.getDate()], ThemesHelperService.getCompany('timezone')).format('ZZ');
      },

      getCardTypeLabel: function(type) {
        return HelpersService.cap(type.toLowerCase());
      },

      done: function() {
        for (var i=0,ii=this.model.cardholders.length;i<ii;i++) {
          if (this.model.cardholders[i].checked) {
            this.model.cardholders[i].expirationDate = CalendarService.toTZISO8601(membershipExpirationDate, this.targetTz);
          }
        }

        $uibModalInstance.close(membershipExpirationDate);
      },

      cancel: function() {
        $uibModalInstance.dismiss();
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipDetailModalsCardholderExpiration.init();

}]);